
import { Component, Prop, Vue } from "vue-property-decorator";

import subscriptions_routes from "@/api/routes/subscriptions";

import Preloader from "@/components/Preloader.vue";
import CInfiniteScroll from "@/components/InfiniteScroll.vue";

import {
  IDataPrograms,
  IStudentProgramsData
} from "@/models/subscriptions/program";

import CTeamSubscription from "./TeamSubscription.vue";
import { IRouteMeta } from "@/router/interface";

@Component({
  name: "CTeamUnscheduledPrograms",
  components: {
    Preloader,
    CInfiniteScroll,
    CTeamSubscription
  }
})
export default class CTeamUnscheduledPrograms extends Vue {
  @Prop({ required: true }) public user_id!: string;

  public preload: boolean = false;
  private preload_infinite: boolean = false;

  private per_page: number = 100;
  private current_page: number = 0;
  private next_page: boolean = false;

  public unscheduled_subscriptions: IStudentProgramsData[] = [];

  private watchers: Function[] = [];

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected async created() {
    this.preload = true;

    await Promise.all([this.loadUnscheduledSubscriptions()]).finally(
      () => (this.preload = false)
    );
  }

  public async infiniteHandler() {
    if (this.next_page && !this.preload_infinite) {
      await this.loadUnscheduledSubscriptions(this.current_page + 1);
    }
  }

  private async loadUnscheduledSubscriptions(page: number = 0) {
    this.preload_infinite = true;

    return this.$api
      .get(subscriptions_routes.assignment_programs_unscheduled(this.user_id), {
        params: {
          page,
          per_page: this.per_page,
          completion_status: "all",
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: IDataPrograms }) => {
        this.current_page = res.current_page;
        this.next_page = res.next_page;
        this.unscheduled_subscriptions.push(...res.programs);
      })
      .finally(() => {
        this.preload_infinite = false;
      });
  }
}
